import type { ReactNode } from "react";
import { Badge, Btn, Card, I } from "../ui";
import { ExtensionInstall } from "./extension/ExtensionInstall";

function Step({ num, title, children }: { num: number; title: string; children: ReactNode }) {
  return (
    <div className="step done" style={{ alignItems: "flex-start", flexDirection: "column", gap: 8 }}>
      <div className="row gap-10" style={{ alignItems: "center" }}>
        <span className="step-num">{num}</span>
        <strong style={{ fontSize: 13.5, color: "var(--text-0)" }}>{title}</strong>
      </div>
      <div className="col gap-8" style={{ fontSize: 13, lineHeight: 1.6, color: "var(--text-1)", paddingLeft: 32 }}>
        {children}
      </div>
    </div>
  );
}

export function Guida({ onGo }: { onGo: (name: string, args?: Record<string, unknown>) => void }) {
  return (
    <div className="col gap-16">
      <Card title="Installa e collega Legacy" sub="Da fare una volta sul computer che userai per SISTER">
        <ExtensionInstall onOpenPairing={() => onGo("extension", { abbina: "1" })} />
      </Card>

      {/* Panoramica */}
      <Card title="Panoramica" sub="Cosa fa il sistema, in breve">
        <div className="col gap-12" style={{ fontSize: 13.5, lineHeight: 1.7, color: "var(--text-1)" }}>
          <p style={{ margin: 0 }}>
            La console raccoglie i <strong style={{ color: "var(--text-0)" }}>necrologi</strong> dai portali configurati,
            cerca i soggetti su <strong style={{ color: "var(--text-0)" }}>SISTER</strong> (Agenzia delle Entrate)
            usando l'estensione Legacy in Chrome o Edge, e produce i <strong style={{ color: "var(--text-0)" }}>Prospect</strong> con
            i dati catastali (codice fiscale, immobili, file visura).
          </p>
          <div className="row gap-8" style={{ flexWrap: "wrap" }}>
            <Badge kind="info">Necrologi</Badge>
            <span className="muted" style={{ alignSelf: "center" }}>{I.arrow}</span>
            <Badge kind="accent">Ricerca su SISTER</Badge>
            <span className="muted" style={{ alignSelf: "center" }}>{I.arrow}</span>
            <Badge kind="accent">Prospect catastali</Badge>
          </div>
          <p className="muted" style={{ margin: 0, fontSize: 12.5 }}>
            L'installazione si fa una volta. Poi, ogni giorno, cinque passi: scegli chi cercare, accedi a SISTER
            e avvia, lascia lavorare l'estensione, controlla gli omonimi e invia a Herobot.
          </p>
        </div>
      </Card>

      <Card title="Ogni giorno" sub="Gli stessi passi che trovi nella Panoramica">
        <div className="steps" style={{ flexDirection: "column", gap: 12, marginBottom: 0 }}>
          <Step num={1} title="Scegli chi cercare">
            <p style={{ margin: 0 }}>
              In <strong style={{ color: "var(--text-0)" }}>Necrologi</strong> premi «Cerca su SISTER…», spunta le
              persone da cercare e conferma. Il filtro «Coniuge non citato» è un'indicazione dal necrologio da verificare.
              Le persone selezionate finiscono nella coda dell'estensione.
            </p>
            <div className="row">
              <Btn variant="primary" size="sm" icon={I.book} onClick={() => onGo("necrologi", { cerca: "1" })}>Scegli chi cercare</Btn>
            </div>
          </Step>

          <Step num={2} title="Accedi a SISTER con SPID e avvia">
            <p style={{ margin: 0 }}>
              Usa il Chrome in cui hai installato l'estensione. Apri il popup Legacy, scrivi il
              <strong style={{ color: "var(--text-0)" }}> Nome richiedente</strong> e premi
              <strong style={{ color: "var(--text-0)" }}> «Prepara SISTER e avvia»</strong>.
            </p>
            <p style={{ margin: 0 }}>
              L'estensione apre il portale dell'Agenzia delle Entrate: <strong style={{ color: "var(--text-0)" }}>il login
              con SPID lo fai tu</strong> (o con CIE o CNS). Dopo il login non toccare niente: l'estensione entra da sola
              in SISTER, apre il modulo <strong style={{ color: "var(--text-0)" }}>«Ricerca per soggetto»</strong> e parte.
            </p>
            <p className="muted" style={{ margin: 0, fontSize: 12.5 }}>
              Se SISTER è già aperto sul modulo «Ricerca per soggetto», il pulsante diventa «Avvia ricerca automatica»
              e parte subito. Per arrivarci a mano: portale AdE → nel campo «Cerca servizio» scrivi «sister» → sulla card
              «Fabbricati e terreni · Sister» premi «Vai al servizio» (non «Adesione ai servizi Sister») → «Consultazioni
              e Certificazioni» → «Visure catastali» → «Conferma Lettura» → ufficio NAZIONALE e «Applica» → «Persona
              fisica». Sei nel posto giusto quando vedi il modulo con i campi Cognome e Nome.
            </p>
          </Step>

          <Step num={3} title="Lascia lavorare l'estensione">
            <p style={{ margin: 0 }}>
              L'estensione cerca le persone una alla volta nella scheda SISTER. Finché lavora:
            </p>
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              <li><strong style={{ color: "var(--text-0)" }}>Non chiudere la scheda SISTER</strong>: se la chiudi la ricerca si ferma.</li>
              <li><strong style={{ color: "var(--text-0)" }}>Non usare quella scheda</strong>: niente clic e niente cambi di pagina.</li>
              <li>
                <strong style={{ color: "var(--text-0)" }}>Non aprire SISTER altrove</strong> (altre schede o altri
                computer con lo stesso SPID): l'Agenzia delle Entrate permette una sola sessione.
              </li>
              <li>Lascia acceso il computer e aperto Chrome. Puoi usare altre schede per altro.</li>
            </ul>
            <p style={{ margin: 0 }}>
              Nel popup, <strong style={{ color: "var(--text-0)" }}>«In attesa della prossima persona in coda»</strong> vuol
              dire che non c'è nessuno da cercare: torna al passo 1 e scegli altre persone. L'estensione le prende da sola.
              Se il popup dice <strong style={{ color: "var(--text-0)" }}>«In pausa»</strong>, leggi il motivo e premi di
              nuovo il pulsante verde.
            </p>
          </Step>

          <Step num={4} title="Controlla gli omonimi">
            <p style={{ margin: 0 }}>
              Quando SISTER trova più persone con lo stesso nome, la scheda compare in
              <strong style={{ color: "var(--text-0)" }}> Prospect → Da controllare</strong>. Confronta data e luogo di
              nascita: se riconosci la persona premi <strong style={{ color: "var(--text-0)" }}>Conferma</strong> e
              l'estensione scarica i suoi immobili; altrimenti premi «Nessuno è la persona giusta».
            </p>
            <div className="row">
              <Btn variant="primary" size="sm" icon={I.layers} onClick={() => onGo("prospects", { vista: "da_controllare" })}>Apri Da controllare</Btn>
            </div>
          </Step>

          <Step num={5} title="Invia a Herobot">
            <p style={{ margin: 0 }}>
              In <strong style={{ color: "var(--text-0)" }}>Prospect → Con immobili</strong> trovi le persone con gli
              immobili letti dalla visura. Controlla la scheda e premi «Invia a Herobot» per passarle all'agenzia.
            </p>
            <div className="row">
              <Btn variant="primary" size="sm" icon={I.layers} onClick={() => onGo("prospects", { vista: "con_immobili" })}>Apri Con immobili</Btn>
            </div>
          </Step>
        </div>
      </Card>

      {/* Problemi comuni */}
      <Card title="Problemi comuni" sub="Cosa fare se qualcosa non torna">
        <div className="col gap-12">
          <div className="preview-box" style={{ fontFamily: "var(--sans)", fontSize: 13, lineHeight: 1.65 }}>
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 4 }}>
              <Badge kind="warn">Aggiornamento estensione</Badge>
            </div>
            <div className="muted">
              Se vedi il badge <strong>↑</strong> sull'icona Chrome o il banner «Estensione non aggiornata» nel popup,
              vai su <strong>Estensione Chrome</strong>, scarica lo ZIP, copia i file nella <strong>stessa cartella</strong> già
              caricata e su <strong>chrome://extensions</strong> premi <strong>Ricarica</strong> (freccia circolare).
              Non caricare una seconda copia. Il numero in alto a destra nel popup deve coincidere con questa pagina.
            </div>
          </div>

          <div className="preview-box" style={{ fontFamily: "var(--sans)", fontSize: 13, lineHeight: 1.65 }}>
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 4 }}>
              <Badge kind="warn">Estensione non abbinata</Badge>
            </div>
            <div className="muted">
              Genera un nuovo codice dalla pagina <strong>Estensione</strong> e incollalo nel popup.
              Il codice scade dopo pochi minuti: se è scaduto, generane uno nuovo.
            </div>
          </div>

          <div className="preview-box" style={{ fontFamily: "var(--sans)", fontSize: 13, lineHeight: 1.65 }}>
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 4 }}>
              <Badge kind="danger">Checklist rossa</Badge>
            </div>
            <div className="muted">
              Una voce rossa indica un passaggio mancante. Controlla di aver compilato il
              <strong> Nome richiedente</strong> e premi «Prepara SISTER e avvia»: l'estensione ti porta lei sul modulo
              <strong> «Ricerca per soggetto»</strong>. A te resta solo il login SPID.
            </div>
          </div>

          <div className="preview-box" style={{ fontFamily: "var(--sans)", fontSize: 13, lineHeight: 1.65 }}>
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 4 }}>
              <Badge kind="warn">La scheda di SISTER è stata chiusa</Badge>
            </div>
            <div className="muted">
              La ricerca lavora dentro una scheda SISTER: se la chiudi, la ricerca si ferma. Premi di nuovo
              <strong> «Prepara SISTER e avvia»</strong>, fai il login se te lo chiede e lascia la scheda aperta.
            </div>
          </div>

          <div className="preview-box" style={{ fontFamily: "var(--sans)", fontSize: 13, lineHeight: 1.65 }}>
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 4 }}>
              <Badge kind="info">In attesa della prossima persona in coda</Badge>
            </div>
            <div className="muted">
              Non è un errore: la coda è vuota. Vai in <strong>Necrologi</strong>, premi «Cerca su SISTER…» e scegli
              le persone. L'estensione le prende da sola, senza riavviarla.
            </div>
          </div>

          <div className="preview-box" style={{ fontFamily: "var(--sans)", fontSize: 13, lineHeight: 1.65 }}>
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 4 }}>
              <Badge kind="danger">Sessione SISTER scaduta</Badge>
            </div>
            <div className="muted">
              Se l'Agenzia delle Entrate ti ha disconnesso, <strong>accedi di nuovo con SPID</strong> e
              riapri SISTER. Poi torna al popup e riavvia la ricerca automatica.
            </div>
          </div>

          <div className="preview-box" style={{ fontFamily: "var(--sans)", fontSize: 13, lineHeight: 1.65 }}>
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 4 }}>
              <Badge kind="danger">Utente già connesso</Badge>
            </div>
            <div className="muted">
              AdE permette <strong>una sola sessione</strong> alla volta. Chiudi le altre tab/Chrome
              (altri computer o altre finestre di Chrome), attendi un minuto, rientra dal portale e riapri
              «Ricerca per soggetto».
            </div>
          </div>

          <div className="preview-box" style={{ fontFamily: "var(--sans)", fontSize: 13, lineHeight: 1.65 }}>
            <div className="row gap-8" style={{ alignItems: "center", marginBottom: 4 }}>
              <Badge kind="warn">Coda ferma / pagina sbagliata</Badge>
            </div>
            <div className="muted">
              L'estensione prova a tornare da sola al modulo <strong>«Ricerca per soggetto»</strong>. Se resta in pausa
              (di solito perché la scheda SISTER è stata usata o ha cambiato pagina), premi di nuovo «Prepara SISTER e avvia».
            </div>
          </div>

          <div className="row gap-8" style={{ flexWrap: "wrap" }}>
            <Btn variant="ghost" size="sm" icon={I.ext} onClick={() => onGo("extension")}>Estensione</Btn>
            <Btn variant="ghost" size="sm" icon={I.layers} onClick={() => onGo("prospects")}>Prospect</Btn>
          </div>
        </div>
      </Card>
    </div>
  );
}
